<!--template for the modal component-->
<template>
    <div v-if="bShowModal" v-on:close="bShowModal = false">
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container-eliminacion">

                        <div class="modal-header">
                            <h2>{{ txtModal.titulo }} de postulación</h2>
                        </div>

                        <div class="modal-body-eliminacion">
                            <div v-html="txtModal.advertencia">

                            </div>
                            
                            <label for="txtMotivo" class="control-label">Motivo de {{ txtModal.label }}(*):</label>
                            <textarea
                                      class="form-control area-responsive"
                                      id="txtMotivo"
                                      name="txtMotivo"
                                      rows="5"
                                      @input="countCharEliminacion($event)"
                                      maxlength="500"
                                      onpaste="return false"
                                      ondrop="return false"
                                      ></textarea>
                            <div>
                                <small>Cantidad de caracteres restantes: &nbsp; <span>{{ contador }}</span></small><br />
                                <small>Los campos con (*) son obligatorios</small>
                            </div>
                            <div v-if="ValidacionMotivo">
                                <div class="alert-vue alert-danger-vue">
                                    <small>Debe ingresar un motivo de {{ txtModal.small }}</small>
                                </div>
                            </div>
                            <div v-if="ValidacionTexto">
                                
                            </div>
                            

                        </div>

                        <div class="modal-footer">
                            <div class="row" style="margin-right:5px;">
                                <button class="btn btn-default" v-on:click="CerrarModal" id="btnSalirMotivo">Salir</button>
                                <button type="button" v-bind:class="accion == 1 ? 'btn btn-primary' : 'btn btn-danger' " :disabled="CampoVacio" id="btnMotivo" v-on:click="EnviarMotivo">{{ txtModal.boton }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    module.exports = {
        name: "modal_motivo",
        props: {
            html_accion: { default: "", type: String },
            mostrar: { default: false, type: Boolean },
            accion: { default: 0, type: Number },
            advmensaje: { default: "", type: String },
        },
        data: function () {
            return {
                bShowModal: false,
                contador: "500",
                ValidacionMotivo: false,
                ValidacionTexto: false,
                CampoVacio: false,
                razon: "",
                oEmisario: {
                    enviar: false,
                    motivo: "",
                },
                txtModal: {
                    titulo: '',
                    label: '',
                    small: '',
                    boton: '',
                    advertencia: '',
                }
            }
        },
        watch: {
            mostrar: {
                inmediate: true,
                handler: function (val, oldVal) {
                    if (val) {
                        this.bShowModal = val;
                    }
                }
            },
            bShowModal: {
                immediate: true,
                handler: function (val, oldVal) {
                    if (!val) {
                        document.ontouchmove = function (e) { return true; }
                        document.body.style.overflow = "inherit";
                    } else {
                        document.ontouchmove = function (e) { e.preventDefault(); }
                        document.body.style.overflow = "hidden";
                    }
                }
            },
            accion: {
                immediate: true,
                handler: function (val, oldVal) {
                    switch (val) {
                        case 1:
                            this.txtModal.titulo = "Modificaci\u00F3n";
                            this.txtModal.label = "modificaci\u00F3n";
                            this.txtModal.small = "modificaci\u00F3n";
                            this.txtModal.boton = "Modificar";
                            this.txtModal.advertencia = this.advmensaje;
                            break;
                        case 2:
                            this.txtModal.titulo = "Eliminaci\u00F3n";
                            this.txtModal.label = "eliminaci\u00F3n";
                            this.txtModal.small = "eliminaci\u00F3n";
                            this.txtModal.boton = "Eliminar";
                            this.txtModal.advertencia = "";
                            break;
                        case 3:
                            this.txtModal.titulo = "Renuncia";
                            this.txtModal.label = "renuncia";
                            this.txtModal.small = "renuncia";
                            this.txtModal.boton = "Renunciar";
                            this.txtModal.advertencia = "";
                            break;
                    }
                }
            }
        },
        methods: {
            checkCaracteres: function (val, nom, exp, msg) {
                if (exp.test(val)) {
                    this.listValidaciones[nom] = "";
                } else {
                    this.listValidaciones[nom] = msg;
                }
            },
            CerrarModal: function () {
                this.$emit('cerrar', false)
                this.bShowModal = false;
            },
            EnviarMotivo: function () {

                if (this.ValidacionTexto == true) {
                    return false;
                }

                var len = this.razon.length;

                if (len > 0) {

                    this.oEmisario.enviar = true;
                    this.oEmisario.motivo = this.razon;

                    this.$emit('emisario', this.oEmisario)
                    this.bShowModal = false;
                } else {
                    this.CampoVacio = true;
                    this.ValidacionMotivo = true;
                }

                
                
            },
            countCharEliminacion: function (evt) {
                
                var val = evt.target.value;
                var exp = /^[a-zA-Z0-9\s\(\)\?\¿\¡\!\"\'\,\;\.\:\-\áéíóúÁÉÍÓÚ]*$/g;
                if (exp.test(val)) {
                    this.ValidacionTexto = false;
                } else {
                    this.ValidacionTexto = true;
                    val = val.substring(0, val.length - 1);
                    document.getElementById("txtMotivo").value = val;
                    return false;
                }

                var len = evt.target.value.length;
                this.CampoVacio = false;
                this.ValidacionMotivo = false;
                this.razon = evt.target.value;

                var val = evt.target.value;
                if (len > 500) {
                    val.value = val.value.substring(0, 500);
                    this.contador = "";
                }
                else {
                    this.contador = 500 - len;
                }
                
                
            },
        },
        mounted: function () {

        }
    }
</script>

<style>

    .loader {
        border: 16px solid #f3f3f3; /* Light grey */
        border-top: 16px solid #3498db; /* Blue */
        border-radius: 50%;
        width: 120px;
        height: 120px;
        animation: spin 2s linear infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }

    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container-eliminacion {
        width: 500px;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h2 {
        margin-top: 0;
        color: #428bca;
    }

    .modal-body-eliminacion {
        margin: 20px 0;
        position: relative;
        height: auto;
        overflow: hidden;
        font-size: 16px;
        padding: 15px;
    }


    .modal-default-button {
        float: right;
    }

    /*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

        .modal-enter .modal-container-eliminacion,
        .modal-leave-active .modal-container-eliminacion {
            -webkit-transform: scale(1.1);
            transform: scale(1.1);
        }


    @media screen and (max-width: 1024px) {
        .modal-container-eliminacion {
            width: 80% !important;
            padding: 0 !important;
        }

        .area-responsive {
            width: 90% !important;
            margin-left: 5% !important;
        }

        .modal-body-eliminacion {
            position: relative;
            height: auto;
            overflow: hidden;
            font-size: 16px;
            padding: 15px;
        }
    }
</style>



// WEBPACK FOOTER //
// Scripts/js/components/modalMotivo.vue